import ReactDOM from 'react-dom/client';
import { ReactQueryProvider } from './providers/ReactQueryProvider';
import { SiteRouter } from './pages';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <ReactQueryProvider>
    <SiteRouter />
  </ReactQueryProvider>
)


